import React, {useEffect,  useContext} from 'react';
import {ListPortfolio, Empty} from 'components/items';
import { portfolioContext } from '../section/PortfolioWithLnb';


const PortfolioContents = () => {
  const {nowLnb, data, setResultList, currentPosts, handleListClick} = useContext(portfolioContext);

  useEffect(()=> {
    if(nowLnb==="all"){
      setResultList(data)
    }else{
      setResultList(data.filter(el => el.category===nowLnb))
    }
  }, [nowLnb, data, setResultList])

  return (
    <div className="PortfolioContents">
      <div className="con">
        <ul className="wrap-portfolio">
          {currentPosts[0]
          ? currentPosts.map((el, index) => {
            return <ListPortfolio el = {el} key = {el.id} index = {index} handleListClick = {handleListClick}/>
          })
          : <Empty text = "준비 중 입니다. "/>}
        </ul>
      </div>
    </div>
  );
}

export default PortfolioContents;